import { em } from 'polished'
import Highlighter from 'react-highlight-words'
import SimpleBar from 'simplebar-react'
import styled from 'styled-components'

export const SearchText = styled(Highlighter)`
  color: ${p => p.theme.colors.muted};

  mark {
    color: ${p => p.theme.colors.black};
    background: none;
  }
`

export const SuggestionsWrapper = styled(SimpleBar)`
  position: absolute;
  z-index: 1;
  top: 100%;
  overflow: auto;
  width: 100%;
  max-height: ${em(215)};
  background: ${p => p.theme.colors.white};
  border-bottom-left-radius: ${p => p.theme.blocks.blockBorderRadius};
  border-bottom-right-radius: ${p => p.theme.blocks.blockBorderRadius};
  box-shadow: ${p => p.theme.colors.blackOp4} 0 0 ${em(20)} 0;
  padding: 0;
  margin: 0;
  margin-top: -2px;
`

export const SuggestionsItem = styled.div`
  padding: ${em(6)} ${em(10)};
  background: ${p =>
    p.selected ? p.theme.colors.aquaHaze : p.theme.colors.COLOR_WHITE};
  cursor: pointer;
  outline: none;
  border-bottom: 1px solid ${p => p.theme.colors.COLOR_GRAY_OP_10};

  ${p => p.theme.mq.upMd} {
    border: none;
  }

  &:last-child {
    border-bottom-left-radius: ${p => p.theme.blocks.blockBorderRadius};
    border-bottom-right-radius: ${p => p.theme.blocks.blockBorderRadius};
    border: none;
  }
`

export const NotFoundItem = styled(SuggestionsItem)`
  color: ${p => p.theme.colors.muted};
  cursor: default;

  &:hover {
    background: ${p => p.theme.colors.COLOR_WHITE};
  }
`
